import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class CommentIconContainer extends React.Component {
  render() {
    return <CommentIcon {...this.props} />;
  }
}

class CommentIcon extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
    size: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    color: IconConstants.DARK_GREY,
    size: 40,
  };

  render() {
    const { getString } = this.context;
    const {
      backgroundColor,
      color,
      size,
    } = this.props;

    return (
      /* eslint-disable max-len */
      <svg width={size} height="100%" viewBox="0 0 40 33" aria-label={getString('AA_Comment_Icon_Desc')}>
        <title>{getString('AA_Comment_Icon_Title')}</title>
        <desc>{getString('AA_Comment_Icon_Desc')}</desc>
        <path
          role="presentation"
          stroke={color}
          strokeWidth="2"
          fill={backgroundColor}
          d="M10.524 30.802l6.134-4.69H36c1.657 0 3-1.344 3-3V4.443c0-1.656-1.343-3-3-3H4c-1.657 0-3 1.344-3 3V23.11c0 1.658 1.343 3 3 3h6.524v4.692z"
        />
        <path
          role="presentation"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="square"
          d="M6.032 13.778h27.936M6.032 18.857H23M6.032 8.698h27.936"
        />
      </svg>
      /* eslint-enable */
    );
  }
}

export default CommentIconContainer;
